import { isMobile } from 'react-device-detect';
import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';
import restClient, { headerKey } from 'services/restClient';
import { environment } from 'environments/environment';

const DocOnSecure = `${environment.REACT_APP_BASE_URL}/DocOnSecure/`;
const firebaseService: any = {
  deviceToken: '',
  userID: '',
  registerToken() {
    if (this.deviceToken)
      restClient.makePostRequest(
        `${DocOnSecure}v2/client/deviceTokens/register`, {
        active: 'true',
        entityType: 'user',
        deviceType: isMobile ? 'mobile-web' : 'desktop',
        applicationId: 'PATIENT_WEB',
        entityId: this.userID,
        deviceToken: this.deviceToken,
      }, {
        headers: {
          [headerKey.Authorization]: restClient.getHeader(headerKey.AccessToken),
        },
      });
  },

  deRegisterToken() {
    return restClient.makePostRequest(
      `${DocOnSecure}v2/client/deviceTokens/deregister`, {
      deviceToken: this.deviceToken,
      applicationId: 'PATIENT_WEB',
    }, {
      headers: {
        [headerKey.Authorization]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  getTk(registration: ServiceWorkerRegistration, messaging) {
    getToken(messaging, { serviceWorkerRegistration: registration, vapidKey: '' })
      .then((currentToken) => {
        if (currentToken) {
          this.deviceToken = currentToken;
          console.log('object :>> ', currentToken);
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  },
  initializeFirebase() {
    try {
      const firebaseApp = initializeApp(environment.firebase);
      const messaging = getMessaging(firebaseApp);

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register(
          '/patientmweb/firebase-messaging-sw.js',
          { scope: '/patientmweb/firebase-cloud-messaging-push-scope' })
          .then(function (registration) {
            console.log('Registration successful, scope is:', registration.scope);
            firebaseService.getTk(registration, messaging);
          }).catch(function (err) {
            console.log('Service worker registration failed, error:', err);
          });
      }

      onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
        const {
          title = '', body,
        } = payload?.notification || {};
        const notify: Notification = new Notification(title, { body });
        notify.onclick = event => {
          event.preventDefault();
        };
      });
    } catch (e) {
      console.log(e);
    }
  },
};

export default firebaseService;